{
  "header": {
    "title": "Question history",
    "description": "Review and analyze previous feedback responses"
  },
  "emptyState": {
    "company": {
      "title": "No data collected yet",
      "description": "Your journey starts here! Once employees begin sharing feedback for first month, you’ll see insights and trends appear"
    },
    "directReports": {
      "title": "No direct reports",
      "description": "You don’t have any direct reports assigned to you, but you can still participate in surveys and share valuable feedback!",
      "bottomAction": {
        "label": "If you think this is a mistake, contact your manager",
        "helpText": "Help text"
      }
    }
  },
  "NotEnoughResponse": {
    "title": "Not enough responses yet",
    "description": "The score will be shown once at least 3 responses are collected"
  },
  "tabs": {
    "company": "Entire company",
    "allReports": "All reports",
    "directReports": "Direct reports",
    "myTeam": "My team"
  },
  "leaderDropdown": {
    "triggerLabel": "Leader",
    "searchPlaceholder": "Find a leader"
  },
  "categoryDropdown": {
    "triggerLabel": "Categories"
  },
  "table": {
    "columns": {
      "date": "Date",
      "question": "Question",
      "category": "Category",
      "satisfactionScore": "Satisfaction Score",
      "responses": "Responses"
    }
  },
  "detailsPage": {
    "header": {
      "description": "Review and analyze previous feedback responses",
      "exportButton": "Export",
      "backButton": "Back to Questions History"
    },
    "tabs": {
      "company": "Entire company",
      "allReports": "All reports",
      "directReports": "Direct reports",
      "myTeam": "My team"
    },
    "leaderDropdown": {
      "triggerLabel": "Leader",
      "searchPlaceholder": "Find a leader"
    },
    "satisfactionScoreSection": {
      "title": "Satisfaction score",
      "barChart": {
        "title": "Answers distribution",
        "agreeTitle": "Agree",
        "somewhatAgreeTitle": "Somewhat agree",
        "neutralTitle": "Neutral",
        "somewhatDisagreeTitle": "Somewhat disagree",
        "disagreeTitle": "Disagree"
      }
    },
    "directReportSection": {
      "title": "Direct report’s team",
      "empty": {
        "title": "No direct-report leaders",
        "description": "This leader doesn't have any subordinate leaders, or data didn't load yet"
      }
    },
    "participationRateSection": {
      "title": "Participation rate"
    },
    "responsesCount_one": "{{count}} response",
    "responsesCount_other": "{{count}} responses",
    "previousResponseSection": {
      "title": "Previous response"
    },
    "enps": {
      "categoryName": "eNPS",
      "questionText": "How likely are you to recommend working for our company?",
      "scoreSection": {
        "title": "eNPS score",
        "companyAverage": "Company average: {{score}}",
        "tooltip": {
          "description": "Employee Net Promoter Score (eNPS) is calculated by surveying employees on a 0–10 scale:",
          "promoters": "Promoters (9–10)",
          "passives": "Passives (7–8)",
          "detractors": "Detractors (0–6)",
          "formulaLabel": "The formula is:",
          "formula": "% Promoters - % Detractors = eNPS",
          "resultRange": "The result ranges from -100 to 100, where a higher score is better. Passives are excluded from the final calculation."
        }
      },
      "distribution": {
        "title": "Distribution of responses",
        "subtitle": "Number of answers",
        "detractors": "Detractors ({{percentage}}%)",
        "passives": "Passives ({{percentage}}%)",
        "promoters": "Promoters ({{percentage}}%)",
        "xAxisLabel": "Answer score"
      },
      "trendSection": {
        "title": "eNPS over time",
        "subtitle": "6 month breakdown",
        "yourTeam": "Your team",
        "companyAverage": "Company average"
      },
      "directReportSection": {
        "title": "Direct report’s team",
        "teamTitle": "{{leaderName}}'s team"
      },
      "previousResponseSection": {
        "title": "Previous response",
        "columns": {
          "date": "Date",
          "score": "eNPS Score",
          "responsePercentage": "Response percentage"
        }
      }
    },
    "table": {
      "columns": {
        "date": "Date",
        "question": "Satisfaction Score",
        "responses": "Response Percentage"
      }
    }
  },
  "titleColumns": "Columns",
  "showAllColumns": "Show all columns",
  "hideAllColumns": "Hide all columns"
}
